import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import get from "lodash/get";
import { getRequest } from './api-client';
import { LoadMoreStoriesManager } from './impl/load-more-stories-manager';
/**
 * This component starts with a set of stories, and then provides a load more button. This calls out to `/api/v1/stories` with the properties passed via the `params` prop. The stories are concatenated with the stories in `props.data.stories`, and the contents of `props.data` are passed to the rendered template.
 *
 * It can accept an alternate `api` as a prop as well as `apiResponseTransformer` which can be used to tranformer the api response before being passed to the `template`.
 *
 * Example
 * ```javascript
 * import { LoadMoreStoriesBase } from '@quintype/components';
 *
 * function SectionPageWithStories({section, stories, loading, onLoadMore, noMoreStories}) {
 *   return <div/>;
 * }
 *
 * export function SectionPage(props) {
 *   return <LoadMoreStoriesBase template={SectionPageWithStories}
 *                               fields={"id,headline"}
 *                               {...props}
 *                               params={{"section-id": props.data.section.id}}
 *                               api="/api/v1/stories"
 *                               apiResponseTransformer={(response) => response.stories} />
 * }
 * ```
 *
 * Also see {@link LoadMoreCollectionStories} for a version that takes a collection
 * @component
 * @category Collection Page
  */

export var LoadMoreStoriesBase = /*#__PURE__*/function (_React$Component) {
  _inherits(LoadMoreStoriesBase, _React$Component);

  var _super = /*#__PURE__*/_createSuper(LoadMoreStoriesBase);

  function LoadMoreStoriesBase() {
    _classCallCheck(this, LoadMoreStoriesBase);

    return _super.apply(this, arguments);
  }

  _createClass(LoadMoreStoriesBase, [{
    key: "loadMoreStories",
    value: function loadMoreStories(pageNumber) {
      var _this = this;

      var stories = get(this.props, ['data', 'stories'], []);
      return getRequest(this.props.api || '/api/v1/stories', Object.assign({}, this.props.params, {
        offset: this.props.numStoriesToLoad * (pageNumber - 1) + stories.length,
        limit: this.props.numStoriesToLoad || 10,
        fields: this.props.fields
      })).json(function (response) {
        if (_this.props.apiResponseTransformer) {
          return _this.props.apiResponseTransformer(response);
        }

        return response.stories || get(response, ['results', 'stories'], []);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(LoadMoreStoriesManager, Object.assign({}, this.props.data, {
        template: this.props.template,
        loadStories: function loadStories(pageNumber) {
          return _this2.loadMoreStories(pageNumber);
        },
        languageDirection: this.props.languageDirection,
        numStoriesToLoad: this.props.numStoriesToLoad || 10
      }));
    }
  }]);

  return LoadMoreStoriesBase;
}(React.Component);